<template>
  <div>
    <div class="header pb-6 d-flex align-items-center profile-header">
      <!-- Mask -->
      <span class="mask bg-gradient-default opacity-8"></span>
      <!-- Header container -->
      <b-container fluid class="d-flex align-items-center">
        <b-row style="margin-top:50px">
          <b-col lg="7" md="10">
            <h1 class="display-2 text-white">Hello AI ...</h1>
            <p class="text-white mt-0 mb-5">
                <!-- This is your profile page. You can see the progress you've made with your
              work and manage your projects or assigned tasks -->
              这是一个“面向聊天编程”的AI引擎，您只需要说出您的想法，即可生成您的量化程序，支持主流的量化语言，如文华、盘立方、同花顺、开拓者、TradingView、MT4/MT5等，也可直接让AI帮你回测、分析、运行。
              </p>
              
            <a class="btn btn-neutral">因为简单 所以简单</a>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col xl="4" class="order-xl-2">
          <user-card></user-card>

          <!-- Progress track -->
          <!-- <card>
            <h5 slot="header" class="h3 mb-0">Progress track</h5>
            <progress-track-list></progress-track-list>
          </card> -->
        </b-col>
        <b-col xl="8" class="order-xl-1">

            <card style="height:430px">
                <b-row align-v="center" slot="header" >
                <b-col cols="12">
                    <h3 class="mb-0" >输入您的交易思路，让AI帮您实现</h3>
                </b-col>
                <!-- <b-col cols="4" class="text-right">
                    <a href="#!" class="btn btn-sm btn-primary">Settings</a>
                </b-col> -->
                </b-row>

                <b-form @submit.prevent="updateProfile">
                <h6 class="heading-small text-muted mb-4" style="font-size:14px">如：请帮忙生成一个文华指标，30日均线金叉做多，死叉平仓</h6>
                <!-- Description -->
                
                <div class="SearchCopilot">
                    <div class="relative w-full" style="min-height: 118px;">
                        <div class="SearchCopilot_searchContainer__K9SFC_1" style="position: absolute;">
                            <textarea v-model="chatContent" class="SearchCopilot_textarea__EPaA1" rows="4" placeholder="您的交易思路是什么？请随便说，我都会竭尽所能为您分析，并生成代码。"></textarea>
                            <div class="SearchCopilot_bottomContainer__mwLV3">
                                <div></div>
                                <div class="SearchCopilot_quickRight__FszXa">
                                    <a @click="onChatBtnClicked()" class="btn"><span class="" data-state="closed">
                                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" class="text-white dark:text-black" style="margin-left:-5px;margin-top:-2px">
                                            <path d="M7 11L12 6L17 11M12 18V7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    
                </div>

                </b-form>

            </card>
           
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
//   import EditProfileForm from './UserProfile/EditProfileForm.vue';
  import UserCard from './UserProfile/UserCard.vue';
  import ProgressTrackList from '@/views/Dashboard/ProgressTrackList';
  import swal from "sweetalert2";

  export default {
    components: {
    //   EditProfileForm,
      UserCard,
      ProgressTrackList
    },
    data() {
        return {
        chatContent:"",
        validated: false,
        model: {
        },
        };
    },
    methods: {
        onChatBtnClicked()
        {
            if(this.chatContent == "" || this.chatContent.trim() == "")
            {
                return;
            }

            localStorage.setItem('chatContent', this.chatContent);

            const userInfo = localStorage.getItem("userInfo");
            const authorization = localStorage.getItem('authorization')
            let isLogin = false;
            if(authorization != null && userInfo == null || userInfo == "" || userInfo == undefined)
            {
            isLogin = false;
            }else{
            const user = JSON.parse(userInfo);
            if(user && user.username != "" && user.username != null)
            {
                isLogin = true;
            }
            }

            if(isLogin)
            {
                window.location.href = "/#/AI";
            }else{
            swal
                .fire({
                title: `请先登陆！`,
                buttonsStyling: false,
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                },
                confirmButtonText: "确定",
                })
                .then(function () {
                window.location.href = "/#/AI";
                });
            }
        },
    }
  };
</script>
<style>
  .profile-header {
    background-image: url(/img/theme/profile-cover.jpg);
    background-size: cover;
    background-position: center top;
    min-height: 500px;
  }

.SearchCopilot
{
    position: relative;
    width: 100%;
}

.SearchCopilot_searchContainer__K9SFC_1 {
    position: relative;
    min-height: 118px;
    background: #fff;
    border: 1px solid #999;
    border-radius: 14px;
    padding: 20px 0 0;
    width: 100%;
    z-index: 10;
    font-size: 14px;
}

.SearchCopilot_searchContainer__K9SFC_1 .SearchCopilot_textarea__EPaA1 {
    padding: 0 8px 0 20px;
    width: 100%;
    display: block;
    border: none;
    height: 220px;
    /* width:1000px;height:140 */
    font-size: 18px;
    font-weight: 400;
    color: #8d8d8d;
    line-height: 20px;
    outline: none;
    resize: none;
    box-shadow: none;
    background-color: transparent;
}

.SearchCopilot_searchContainer__K9SFC_1 textarea::placeholder {
  color: #a8a7a7;
}


.SearchCopilot_quickRight__FszXa .btn {
    background: #ff6900;
    border: 1px solid #ff6900;
    border-radius: 8px;
    color: #fff;
    font-size: 16px;
    /* 
    line-height: 40px; */
    height: 50px;
    position: absolute;
    right: 24px;
    
    text-align: center;
    text-decoration: none;
    top: 80%;
    transform: translateY(-80%);
    width: 60px;
}
</style>
